import gql from "../gql";
import Learning from "./Learning";
export default gql `
  fragment Learnings on LearningSummaryConnection {
    __typename
    edges {
      __typename
      node {
        ...Learning
      }
    }
    pageInfo {
      __typename
      startCursor
      endCursor
      hasNextPage
    }
  }
  ${Learning}
`;
